import { Sparkles } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../../../lib/cn';
import { useAccess } from '../../../lib/useAccess';
import { Button } from '../../../ui';
import { TOUCH_BUTTON } from '../../mobile';
import { type DelegateTarget, DelegateToClaudeDialog } from './DelegateToClaudeDialog';

/**
 * Przycisk „Zleć Claude” z oknem zlecenia (Fala 9): incydent monitoringu, błąd integracji (Ustawienia → Integracje).
 * Widoczny tylko z modułem Agenci (Edycja) — backend (`agents.create`) i tak sprawdza uprawnienia i zakres.
 * `target` liczony przy otwarciu (instrukcja z aktualnych danych widoku).
 */
export function DelegateToClaudeButton({
  target,
  variant = 'secondary',
  fullWidth,
  className,
}: {
  target: () => DelegateTarget;
  variant?: 'secondary' | 'ghost';
  fullWidth?: boolean;
  className?: string;
}) {
  const access = useAccess();
  const [open, setOpen] = useState<DelegateTarget | null>(null);
  if (!access.can('agents', 'edit')) return null;
  return (
    <>
      <Button
        variant={variant}
        icon={Sparkles}
        fullWidth={fullWidth}
        className={cn(TOUCH_BUTTON, className)}
        onClick={() => setOpen(target())}
      >
        Zleć Claude
      </Button>
      {open && (
        <DelegateToClaudeDialog
          target={open}
          open
          onOpenChange={(o) => {
            if (!o) setOpen(null);
          }}
        />
      )}
    </>
  );
}
